<template>
    <v-dialog
        v-model="skypeIdDialogs.dialog"
        :max-width="options.width"
        v-bind:style="{ zIndex: options.zIndex }"
        :persistent="true">
        <v-card class="pa-3">
            <v-card-title class="title pa-3 text-xs-center blue-title">
                <v-spacer></v-spacer>
                <div class="header-close" title="close" @click="skypeIdDialogs.dialog=false"><v-icon>close</v-icon></div>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>   
                <v-container grid-list-md class="pa-0">
                    <div class="subheading referral-bonus pl-0 blue-title">
                        Dear tutors，kindly update your skype ID in the system so that we can communicate with each other easier. 
                    </div>
                </v-container>
            </v-card-text>
            <v-card-actions class="pt-4 pb-3" style="padding: 16px">
                <v-layout>
                    <v-flex class="text-xs-right mr-4">
                        <v-text-field :error-messages="$v.Sky.$error ? 'Required': ''" @input="$v.Sky.$touch()" v-model.trim="Sky" required single-line outline box placeholder="Sky" class="body-2"></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-btn class="text-none red-button" @click="submitSkype" :loading="Loading">Submit</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { addSkypeId } from '@/api/teachinfo'
import { _debounce } from "@/utils/tools.js";
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
    mixins: [validationMixin],
    validations: {
      Sky: { required }
    },
    props: {
        skypeIdDialogs: {
            dialog: false
        }
    },
    data: ()=>({
        dialog:false,
        options:{
            width: 550,
            zIndex: 200
        },
        Sky: '',
        Loading: false

    }),
    methods:{
        submitSkype: _debounce(async function() {
            this.$v.Sky.$touch();
            if (this.$v.Sky.$invalid) {
                this.Loading = false;
                return;
            }
            this.Loading = true
            var result = await addSkypeId({Sky:this.Sky})
            this.Loading = false;
            var type = result.data.ErrorCode === 0 ? "success" : "error";
            await this.$root.$alertTips(result.data.Msg, type)
            this.skypeIdDialogs.dialog = false
        })
    }
}
</script>

<style scoped>
    .red-button{
        height: 38px;
    }
    
</style>